import { Component, enableProdMode, Inject, OnInit, ViewChild } from '@angular/core';
import { CitasService } from 'src/app/services/citas.service';
import { MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource} from '@angular/material/table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

enableProdMode();
@Component({
  selector: 'app-resumen-citas',
  templateUrl: './resumen-citas.component.html',
  styleUrls: ['./resumen-citas.component.css']
})
export class ResumenCitasComponent implements OnInit {

  displayedColumns: string[] = ['estatusVidellamada', 'atendida', 'cancelada', 'observacion','nombre', 'email', 'telefono', 'empresa', 'estado', 'ocupacion','medio', 'descripcion','fecha', 'hora', 'meet'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private service: CitasService, public dialog: MatDialog) { }

 async ngOnInit() {
    try {
      const get = await this.service.getResumenCitas();
      this.dataSource = new MatTableDataSource<any>(get)
      this.dataSource.paginator = this.paginator;
      

    } catch (error) {
      console.log(error);
    }
  }

   applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onClick(value){
    const dialog=this.dialog.open(DescripcionDialog, {
      data: {
        mensaje: value
      }
    });
  }

  changeEstatus(value, element){
    const dialog=this.dialog.open(ObservacionesDialog,{
      height: '30%',
      width: '30%',
      data: {
        estatus: value, 
        email: element.email,
        id: element.id,
        idCalendar: element.idCalendar
      }
    });
    dialog.afterClosed().subscribe(result=>{
      if(result===0){
        window.location.reload();
      }
    })
  }
  
  ngAfterViewInit() {
  }

}


@Component({
  selector: 'descripcionDialog',
  templateUrl: 'descripcionDialog.html',
})
export class DescripcionDialog {

  constructor(
    public dialogRef: MatDialogRef<DescripcionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {  dialogRef.disableClose = true;}

  onNoClick(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'observacionesDialog',
  templateUrl: 'observacionesDialog.html',
})
export class ObservacionesDialog {

  observaciones: string;

  constructor(
    public dialogRef: MatDialogRef<ObservacionesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, private service: CitasService) { 
       dialogRef.disableClose = true;
       this.observaciones = '';
    }

  async actualizar() {
    const request ={
      id : this.data.id,
      email: this.data.email,
      estatus: this.data.estatus,
      observaciones: this.observaciones,
      idCalendar: this.data.idCalendar
    }
    try{
      const post = await this.service.updateStatus(request);      
    } catch (error) {
      console.log(error);
    }

    this.dialogRef.close(0);
  }

  cancelar(): void {
    this.dialogRef.close(1);
  }

}